/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { ORGContactInformationComponent } from '../ORG_contact_information/ORG_contact_information.component';
import { FAQComponent } from '../FAQ/FAQ.component';
//import { AdditionalInfoComponent } from '../additional_info/additional_info.component';
import { ProvincialPaymentComponent } from '../provincial_payment/provincial_payment.component';
import { NextRegistrationComponent } from '../next_registration/next_registration.component';
import { OrderSummaryComponent } from '../order_summary/order_summary.component';
import { ESRAreYouSureComponent } from '../ESR_are_you_sure/ESR_are_you_sure.component';
import { ESRMainComponent } from '../ESR_main/ESR_main.component';
import { SINAreYouSureComponent } from '../SIN_are_you_sure/SIN_are_you_sure.component';
import { SINMainComponent } from '../SIN_main/SIN_main.component';
import { CCBAreYouSureComponent } from '../CCB_are_you_sure/CCB_are_you_sure.component';
import { CCBMainComponent } from '../CCB_main/CCB_main.component';
import { Transition2Component } from '../transition_2/transition_2.component';
import { BirthCertificateAreYouSureComponent } from '../birth_certificate_are_you_sure/birth_certificate_are_you_sure.component';
import { BirthCertificateComponent } from '../birth_certificate/birth_certificate.component';
import { Transition1Component } from '../transition_1/transition_1.component';
import { FinalReviewComponent } from '../final_review/final_review.component';
import { ContactInfoAndMailingAddressComponent } from '../contact_info_and_mailing_address/contact_info_and_mailing_address.component';
import { AboutTheParentsScreen1Component } from '../about_the_parents_screen/about_the_parents_screen_1.component';
import { AboutTheParentsScreen2Component } from '../about_the_parents_screen/about_the_parents_screen_2.component';
import { AboutTheParentsScreen3Component } from '../about_the_parents_screen/about_the_parents_screen_3.component';
import { AboutTheParentsScreen4Component } from '../about_the_parents_screen/about_the_parents_screen_4.component';
import { AboutTheParentsMainComponent } from '../about_the_parents_main/about_the_parents_main.component';
import { AboutTheChildScreen2Component } from '../about_the_child_screen_2/about_the_child_screen_2.component';
import { AboutTheChildMainComponent } from '../about_the_child_main/about_the_child_main.component';
import { Setup5Component } from '../setup_5/setup_5.component';
import { Setup4Component } from '../setup_4/setup_4.component';
import { Setup3Component } from '../setup_3/setup_3.component';
import { Setup2Component } from '../setup_2/setup_2.component';
import { Setup1Component } from '../setup_1/setup_1.component';
import { BeforeYouBeginComponent } from '../before_you_begin/before_you_begin.component';
import { StartComponent } from '../start/start.component';
import { ErrorComponent } from '../error/error.component';
import { Path } from  "../_common/constant/page-const";
const routes: Routes = [
      /* page list  */
      { path: Path.Start, component: StartComponent },
      { path: Path.BeforeYouBegin, component: BeforeYouBeginComponent },
      { path: Path.Setup1, component: Setup1Component },
      { path: Path.Setup2, component: Setup2Component },
      { path: Path.Setup3, component: Setup3Component },
      { path: Path.Setup4, component: Setup4Component },
      { path: Path.Setup5, component: Setup5Component },
      { path: Path.AboutTheChildMain, component: AboutTheChildMainComponent },
      { path: Path.AboutTheChildScreen2, component: AboutTheChildScreen2Component },
      { path: Path.AboutTheParentsMain, component: AboutTheParentsMainComponent },
      { path: Path.AboutTheParentsScreen1, component: AboutTheParentsScreen1Component },
      { path: Path.AboutTheParentsScreen2, component: AboutTheParentsScreen2Component },
      { path: Path.AboutTheParentsScreen3, component: AboutTheParentsScreen3Component },
      { path: Path.AboutTheParentsScreen4, component: AboutTheParentsScreen4Component },
      { path: Path.ContactInfoAndMailingAddress, component: ContactInfoAndMailingAddressComponent },
      { path: Path.FinalReview, component: FinalReviewComponent },
      { path: Path.Transition1, component: Transition1Component },
      { path: Path.BirthCertificate, component: BirthCertificateComponent },
      { path: Path.BirthCertificateAreYouSure, component: BirthCertificateAreYouSureComponent },
      { path: Path.Transition2, component: Transition2Component },
      { path: Path.CCBMain, component: CCBMainComponent },
      { path: Path.CCBAreYouSure, component: CCBAreYouSureComponent },
      { path: Path.SINMain, component: SINMainComponent },
      { path: Path.SINAreYouSure, component: SINAreYouSureComponent },
      { path: Path.ESRMain, component: ESRMainComponent },
      { path: Path.ESRAreYouSure, component: ESRAreYouSureComponent },
      { path: Path.OrderSummary, component: OrderSummaryComponent },
      { path: Path.NextRegistration, component: NextRegistrationComponent },
      { path: Path.ProvincialPayment, component: ProvincialPaymentComponent },
      ///{ path: Path.Receipt, component: ReceiptComponent },
      //{ path: Path.AdditionalInfo, component: AdditionalInfoComponent },
      { path: Path.FAQ, component: FAQComponent },
      { path: Path.ORGContactInformation, component: ORGContactInformationComponent },
      { path: Path.error, component: ErrorComponent },
      ///{ path: Path.Error, component: ErrorComponent },
      { path:'',redirectTo:Path.Start, pathMatch: 'full' },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

